/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Detail_RewardsInputs */

const en_campaigns_mag7_detail_rewards = /** @type {(inputs: Campaigns_Mag7_Detail_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your portfolio rebalances daily on its own, and rewards accrue on your balance for as long as you hold it, paid out at least once a day.`)
};

const de_campaigns_mag7_detail_rewards = /** @type {(inputs: Campaigns_Mag7_Detail_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Portfolio wird täglich automatisch neu gewichtet. Solange Sie es halten, sammeln sich Prämien auf Ihrem Guthaben an und werden mindestens einmal täglich ausgezahlt.`)
};

const pt_br2_campaigns_mag7_detail_rewards = /** @type {(inputs: Campaigns_Mag7_Detail_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu portfólio é rebalanceado automaticamente todos os dias. Enquanto você mantiver o investimento, as recompensas se acumulam sobre seu saldo e são pagas pelo menos uma vez ao dia.`)
};

const tr_campaigns_mag7_detail_rewards = /** @type {(inputs: Campaigns_Mag7_Detail_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portföyünüz her gün otomatik olarak yeniden dengelenir. Portföyü elinizde tuttuğunuz sürece bakiyeniz üzerinden ödüller birikir ve günde en az bir kez ödenir.`)
};

const zh_cn2_campaigns_mag7_detail_rewards = /** @type {(inputs: Campaigns_Mag7_Detail_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投资组合每日自动再平衡，只要持有，奖励便会按余额持续累积，且每天至少发放一次。`)
};

const zh_hk2_campaigns_mag7_detail_rewards = /** @type {(inputs: Campaigns_Mag7_Detail_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投資組合會每日自動重新平衡，只要你繼續持有，獎賞就會按結餘累積，並最少每日派發一次。`)
};

const ko_kr2_campaigns_mag7_detail_rewards = /** @type {(inputs: Campaigns_Mag7_Detail_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포트폴리오는 매일 자동으로 리밸런싱되며, 보유하는 동안 잔액에 리워드가 쌓이고 최소 하루 한 번 지급됩니다.`)
};

const ru_ru2_campaigns_mag7_detail_rewards = /** @type {(inputs: Campaigns_Mag7_Detail_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Портфель ребалансируется ежедневно и автоматически, а вознаграждения начисляются на баланс всё время, пока вы его держите, и выплачиваются не реже раза в день.`)
};

const es_419_campaigns_mag7_detail_rewards = /** @type {(inputs: Campaigns_Mag7_Detail_RewardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu portafolio se rebalancea a diario por sí solo, y las recompensas se acumulan sobre tu saldo mientras lo mantengas, con pagos al menos una vez al día.`)
};

/**
* | output |
* | --- |
* | "Your portfolio rebalances daily on its own, and rewards accrue on your balance for as long as you hold it, paid out at least once a day." |
*
* @param {Campaigns_Mag7_Detail_RewardsInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_detail_rewards = /** @type {((inputs?: Campaigns_Mag7_Detail_RewardsInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Detail_RewardsInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_detail_rewards(inputs)
	if (locale === "de") return de_campaigns_mag7_detail_rewards(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_detail_rewards(inputs)
	if (locale === "tr") return tr_campaigns_mag7_detail_rewards(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_detail_rewards(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_detail_rewards(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_detail_rewards(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_detail_rewards(inputs)
	return es_419_campaigns_mag7_detail_rewards(inputs)
});